import { useEffect, useState } from "react";
import HorizonaylCharts from "../../ui/HorizontalCharts/HorizonaylCharts";
import SingleTabTable from "../../ui/SingleTabTable";
import WidgetWrapper from "../widget-wrapper/widget-wrapper";
import ChartSkeleton from "../../ui/chart-skeleton/chart-skeleton";
import SingleLineCharts from "../../ui/SinglelineCharts/singlelineCharts";
import { useSamarthDashboardContext } from "utils/samarth-dashboard-context/hooks/useSamarthDashboardContext";
import { useKpiData } from "utils/samarth-dashboard-context/hooks/useKpiData";
import styles from "../maiWidgets/mai-widget.module.css";

const FGCoverageWidget = () => {
  const { state } = useSamarthDashboardContext();
  const globalViewMode = state.viewMode.globalViewMode;
  const loader = state.dashboardData.isLoading.fgCoverage;
  const chartData = state.dashboardData.fgCoverage;
  const { filters } = useKpiData();
  const { actionFilters: actionFilter, currentWeek: currWeek } = filters;

  const [visibleData, setVisibleData] = useState([]);
  const [isOn, setIsOn] = useState(false);

  const handleToggle = () => setIsOn((prev) => !prev);

  useEffect(() => {
    if (!Array.isArray(chartData)) return;

    if (actionFilter) {
      const weekKey = globalViewMode === "graph" ? currWeek : state.dashboardData.weekCurrent;
      const weekData = chartData[0]?.[weekKey] || [];

      setVisibleData(isOn ? weekData : weekData.slice(0, 4));
    } else {
      setVisibleData(isOn ? [...chartData] : [...chartData].slice(0, 4));
    }
  }, [chartData, isOn, currWeek, globalViewMode, actionFilter, state.dashboardData.weekCurrent]);

  const renderChart = () => {
    if (globalViewMode === "graph") {
      return actionFilter ? (
        <SingleLineCharts data={visibleData} isExpansionNeeded />
      ) : (
        <div style={{ height: "100%", width: "100%" }}>
          <HorizonaylCharts data={[...visibleData]} />
        </div>
      );
    } else {
      return (
        <SingleTabTable
          data={visibleData}
          keys={["week", "value"]}
          colorLogic={(value) => {
            if (value > 80) return styles.textGreen;
            if (value > 60) return styles.textYellow;
            return styles.textRed;
          }}
        />
      );
    }
  };

  return (
    <WidgetWrapper
      title="FG Coverage"
      isTableView={globalViewMode === "table"}
      isDialogOpen={isOn}
      setIsDialogOpen={handleToggle}
      infoText='FG coverage indicates how much of the FG production plan can be met with available RMPM inventory.'
    >
      <div style={{ height: "100%", width: "100%" }}>
        {loader ? <ChartSkeleton isOn={isOn} /> : renderChart()}
      </div>
    </WidgetWrapper>
  );
};

export default FGCoverageWidget;
